<template>
  <div class="wave-image-block wave-text-block"
     :class="{wave_block_green: is_green}">
    <wave-new-icon
      class="wave-image-block__fill"
    />
    <div class="wave-image-block__content position-relative">
      <div class="wave-text-block__title">{{title}}</div>
      <html-block
        class="wave-text-block__content mt-30 mt-xs-0"
        :content="content"
      />
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import WaveNewIcon from "../../fill_svg/waves/WaveNewIcon.vue";
import ArrowTextHover from "../../small_parts/ArrowTextHover.vue";
import DefaultTitle from "../../small_parts/DefaultTitle.vue";
import HtmlBlock from "../../small_parts/HtmlBlock.vue";

export default {
  name: "WaveTextBlock",
  components: {
    HtmlBlock,
    DefaultTitle,
    ArrowTextHover,
    WaveNewIcon
  },
  props: {
    href: {
      type: String,
      default: '#',
    },
    image_lazy_src: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    is_green: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
  }
}
</script>
